// extracted by mini-css-extract-plugin
export default {"root":"Header_root__HUGDd","logo":"Header_logo__8Ki-h"};